// extracted by mini-css-extract-plugin
export default {"viewForm":"view-form_viewForm__YlpED"};